<template>
    <b-overlay :show="showoverlay" rounded="sm">
        <div class="card mt-0 border-0 bg-white no-shadow">

            <div class="card-header px-0 bg-transparent border-0">
                <div class="row no-margin">
                    <div class="col-sm-7 pl-0 row" >
                        <div class="col-8 align-self-center custom-search pr-0 mt-2" style="max-width: 450px;">
                            <b-input-group >
                                <b-input-group-prepend is-text>
                                    <b-icon icon="search"></b-icon>
                                </b-input-group-prepend>
                                <b-form-input type="search" placeholder="Search by employee / position / branch / email / phone" v-model="search" @input="resetPagination()"></b-form-input>
                            </b-input-group>
                        </div>
                        <!-- <div class="col-4 mt-2 company-employee-count" style="height: 31px; position: unset;"> -->
                        <div class="pl-2 mt-3 company-employee-count" style="height: 31px; position: unset;">
                            <span class="text-center px-2 border border-right-0 d-inline-block h-100 employee-count-icon"><b-icon class="" icon="people-fill"></b-icon></span>
                            <span class="text-center px-2 border d-inline-block h-100 employee-count-number" style="min-width: 51px;">{{people}}</span>
                        </div>
                    </div>
                    <div class="col-sm-5 pr-0">
                        <div class="col-12 text-right pr-0 trz_ppl_wrapper_2">
                            <div class="d-inline-block trz_fields trz-custom-dropdown mb-1" v-if="viewmode">
                                <b-dropdown id="dropdown-fields" text="Fields" ref="dropdown" class="mb-1">
                                <b-dropdown-form>
                                    <b-form-group @submit.stop.prevent>
                                        <div class="form-group">
                                            <b-form-checkbox-group
                                                v-model="column_selected"
                                                :options="column_options"
                                                switches

                                            />
                                        </div>
                                        <button type="button" @click="setcolumn()" class="btn btn-primary">Save</button>
                                    </b-form-group>
                                </b-dropdown-form>
                                </b-dropdown>
                            </div>
                            <b-button  id="filter_button" class="employee-filter-btn mb-1 custom-secodary-btn" v-b-toggle.sidebar_right>Filter<b-icon class="ml-3" icon="funnel-fill" ></b-icon></b-button>
                            <b-button v-if="switch_view==1" class="view-mode-btn employee-filter-btn mb-1 custom-secodary-btn" @click="viewmode = !viewmode">Switch View<b-icon v-if="viewmode" class="ml-3 list-icon" icon="list-ul"></b-icon><b-icon v-else class="ml-3 grid-icon" icon="grid3x3-gap-fill"></b-icon></b-button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-body container px-0" >
                <div class="wrapper1" v-if="viewmode">
                    <div class="div1"></div>
                </div>
                <!-- list view starts here -->
                <div class="wrapper2 mb-4 " v-if="viewmode">
                    <div class="div2">
                        <table class="employee-list-table table-responsive dataTable table-sticky" v-if="viewmode">

                            <thead>
                                <tr class="table-head ">
                                    <td class="checkbox-col" v-if="checkbox==1">
                                        <input type="checkbox" v-model="selectAll" class="">
                                        <label></label>
                                    </td>

                                    <td v-for="f in default_column">
                                        <template v-for="k in default_options">
                                            <template v-if="f == k.value  && f =='leave_type'" >
                                            </template>
                                            <template v-else-if="f == k.value  && f !='name'" >
                                                <label class="custom-label" :class="sortKey === k.value ? (sortOrders[k.value] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"   @click="sortBy(k.value)">
                                                    <span><template v-if="k.text == 'Jobposition'">Job Position</template><template v-else>{{k.text}}</template></span>
                                                </label>
                                            </template>
                                            <template v-else-if="f == k.value  && f =='name'" >
                                                <!-- <input v-if ="checkbox==1" type="checkbox" v-model="selectAll" class=""> -->
                                                <label class="custom-label pl-5" :class="sortKey === k.value ? (sortOrders[k.value] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"   @click="sortBy(k.value)">
                                                    <span>{{k.text}}</span>
                                                </label>
                                            </template>
                                        </template>
                                    </td>
                                    <td v-for="f in appended_column">
                                        <template v-for="k in appended_options">
                                            <template v-if="f.value == k.value" >
                                                <label class="custom-label" :class="sortKey === k.value ? (sortOrders[k.value] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"   @click="sortBy(k.value)">
                                                    <span><template v-if="k.text == 'Jobposition'">Job Position</template><template v-else>{{k.text}}</template></span>
                                                </label>
                                            </template>
                                        </template>
                                    </td>
                                    <td v-for="f in column_selected">
                                        <template v-for="k in column_options">
                                            <template v-if="f == k.value" >
                                                <label class="custom-label" :class="sortKey === k.value ? (sortOrders[k.value] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"   @click="sortBy(k.value)">
                                                    <span><template v-if="k.text == 'Jobposition'">Job Position</template><template v-else>{{k.text}}</template></span>
                                                </label>
                                            </template>
                                        </template>
                                    </td>
                                    <td v-if="is_action==1" class="action_thead">Action</td>

                                </tr>
                            </thead>
                            <tbody>
                                <tr class="hover-bg table-row" v-for="employee in paginatedData" :key="employee[primary_key]">
                                    <template v-if="checkbox==1">
                                        <td class="checkbox-col">
                                            <input type="checkbox" class="justify-content-center" v-model="selected" :value="employee.employee_id" number>
                                            <label></label>
                                        </td>
                                    </template>

                                    <td class="cursor-pointer"   v-for="f in default_column">
                                        <template v-if="f == 'phone'"><span class="cursor-pointer" >{{formatPhoneNumber(employee.phone)}}</span></template>
                                        <template v-else-if="f == 'name' ">
                                            <!-- <input v-if ="checkbox==1" type="checkbox" class="justify-content-center" v-model="selected" :value="employee.employee_id" number> -->
                                            <label class="mb-0 custom-label">
                                                <img v-if="employee.pic != ''" v-bind:src="'/avatar/'+ employee.company_id + '/' + employee.pic" class="img-fluid img-thumbnail employee-avatar mx-2" />
                                                <img v-else v-bind:src="'/avatar/demo.jpg'" class="img-fluid img-thumbnail employee-avatar mx-2" />
                                                <span class="cursor-pointer" >{{employee.name}}</span>
                                            </label>
                                        </template>

                                        <template v-else-if="f == 'leave_policy'"><div :id="employee[primary_key]+'_'+employee[f]">{{employee[f]}}</div>
                                            <b-tooltip :target="employee[primary_key]+'_'+employee[f]" triggers="hover">
                                                {{employee['leave_types']}}
                                            </b-tooltip>
                                        </template>

                                        <template v-else-if="f == 'leave_type'">
                                        </template>
                                        <template v-else>{{employee[f]}}</template>
                                    </td>
                                    <td class="cursor-pointer"   v-for="f in appended_column">
                                        <template ><span class="cursor-pointer">{{employee[f.value]}}</span></template>
                                    </td>
                                    <td class="cursor-pointer"   v-for="f in column_selected">
                                        <template v-if="f == 'leave_policy'"><div :id="employee[primary_key]+'_'+employee[f]">{{employee[f]}}</div>
                                            <b-tooltip :target="employee[primary_key]+'_'+employee[f]" triggers="hover">
                                                {{employee['leave_types']}}
                                            </b-tooltip>
                                        </template>
                                        <template v-else><span class="cursor-pointer" >{{employee[f]}}</span></template>
                                    </td>
                                    <td v-if="is_action==1" class="action_td">
                                        <div class="col-sm-2 py-1 pl-0 pr-3 float-right">
                                            <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                            <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                                <b-button-group >
                                                    <div v-for="(row, index) in employee.actions" :key="index">
                                                    <b-button variant="outline-secondary"  @click="actionEmployee(employee[primary_key],row.value)">
                                                    <b-icon icon="gear"></b-icon>{{row.label}}
                                                    </b-button>

                                                    </div>

                                                </b-button-group>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <!-- list view ends here -->
                <!-- grid view starts here -->
                <div class="grid-view my-3 clearfix employee-grid-view" v-else>
                    <div class="container-fluid px-0">
                        <div class="grid">
                            <div class="grid-item hover-bg" v-for="employee in paginatedData" :key="employee[primary_key]">
                                <div class="grid-employee-img">
                                    <img v-if="employee.pic != ''" v-bind:src="'/avatar/'+ employee.company_id + '/' + employee.pic" class="img-fluid img-thumbnail" />
                                    <img v-else v-bind:src="'/avatar/demo.jpg'" class="img-fluid img-thumbnail" />
                                </div>
                                <div class="grid-employee-data text-center">
                                    <span>{{employee.name}}</span>
                                    <span>{{employee.jobposition}}<span v-if="employee.department !== '' && employee.jobposition !== ''">, </span> {{employee.department}}</span>
                                </div>
                                <div class="grid-employee-viewmore mt-4">
                                    <b-button variant="primary" class="w-100" title="Edit" v-if="viewmode==false" >View Details</b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- grid view ends here -->
                <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
                    <div class="col-md-12 p-0 no-margin" v-if="paginatedData.length > 0">
                        <ul class="pagination b-pagination float-left mb-0 mt-1">
                            <li class="page-item disabled m-2">View</li>
                            <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                            <li class="page-item disabled m-2">per page. Total {{people}} records found.</li>
                        </ul>
                        <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>
                    </div>

                </div>
                <div class="row p-4 no-gutters justify-content-center align-items-center" v-if="paginatedData.length == 0">
                    <p class="mb-0 mr-3">{{blankmsg}}</p>
                </div>
            </div>

            <b-sidebar id="sidebar_right" title="Filter" right shadow>
                <filter-list-leave :leave_type_options="leave_type_options" :key="sidebar_key" :company_options="company_options" :search_by_filter="search_by_filter" :default_column="default_column"  :column_selected="column_selected"  v-on:childToParent="filterList"></filter-list-leave>
            </b-sidebar>
            {{clickSelect}}
        </div>

    </b-overlay>
</template>


<script>
export default{
        props: ['employees','default_column','appended_column','company_options','leave_type_options','primary_key','checkbox','is_action','switch_view'],

        data(){

            let sortOrders = {};

            //columns.forEach((column) => {sortOrders[column.name] = -1;});

            return {

                columns: [],
                sortKey: 'name',
                sortOrders: sortOrders,
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},
                tmp_column_selected: [],
                column_selected: [], // Must be an array reference!
                default_options: [],
                appended_options: [],
                column_options:[],
                search_by_filter:[],
                selected: [],
                backdoor: 0,
                sidebar_key:0,
                selected_ids :[],
                showoverlay : true,
                viewmode :true,
                notice: "Looks like you have not added any employee yet.",
                blankmsg : 'Fetching data..',
                people:0,
                company_name : '',
                filter_by_id:['jobposition_id','department_id','branch_id','leave_policy_id','leave_type_id'],
                search:'',
                length: 20,
                temp_length: 20,
                length_options: [],
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},

            }
        },
        methods:{

            sortBy(key)
            {
                this.resetPagination();
                this.sortKey = key;
                this.sortOrders[key] = this.sortOrders[key] * -1;

                this.backdoor++;
            },
            filterList(value)
            {
                this.resetPagination();

                if(value['toggle'])
                {
                    if(value['toggle'] == 1)
                    {
                        $("#sidebar_right").toggle();
                    }
                }
                if(value['reset'] == 1)
                {
                    this.search_by_filter = value['search_by_filter'];
                    this.sortBy('name');
                    $("#filter_button").click();

                    //this.resetFlter();
                }
            },

            stringView(str) {
                var i, frags = str.split('_');
                for (i=0; i<frags.length; i++) {
                    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
                }
                return frags.join(' ');
            },
            getIndex(array, key, value)
            {
                return array.findIndex(i => i[key] == value)
            },

            setcolumn: function()
            {
                this.$cookies.set("column_selected", this.column_selected);

                this.$refs.dropdown.hide(true);
            },
            toMoney: function(amount)
            {
                if(amount !="0")
                {
                        if(!isNaN(amount))
                        {
                            var number = Number(amount);
                            return number;
                        }
                    var NumWithoutCommas = amount.replace(/,/g, '');
                    var number = Number(NumWithoutCommas).toFixed(2);
                    return number;
                }else
                    return amount;
            },

            generateList: function()
            {

                this.showoverlay = true;
                if(this.employees.length>0)
                {
                    let cr = {};

                    this.company_options.forEach(element => {

                        if(element.label=='jobposition')
                        {
                            cr['jobposition_id'] = '';
                        }
                        else if(element.label=='department')
                        {
                            cr['department_id'] = '';
                        }
                        else if(element.label=='branch')
                        {
                            cr['branch_id'] = '';
                        }
                        else if(element.label=='leave_policy')
                        {
                            cr['leave_policy_id'] = '';
                        }
                        else if(element.label=='leave_type')
                        {
                            cr['leave_type_id'] = '';
                        }
                        else
                        {
                            cr[element.label] = '';
                        }

                    });

                    this.search_by_filter = cr;
                    let co = [];
                    let cl = [];
                    let dop = [];
                    this.company_options.forEach(element => {
                            if(1)
                            {
                            cl = cl.concat([{ label: this.stringView(element.label) , name: element.label,type:element.type}]);

                            if(!this.default_column.includes(element.label))
                            {
                                co = co.concat([{ text: this.stringView(element.label) , value: element.label }]);
                            }
                            if(this.default_column.includes(element.label))
                            {
                                dop = dop.concat([{ text: this.stringView(element.label) , value: element.label }]);
                            }
                            }



                    });
                    let aop = [];
                    let aopcl = [];
                    for(let i = 0; i < this.appended_column.length; i++)
                    {
                        aop = aop.concat([{ text: this.stringView(this.appended_column[i].text) , value: this.appended_column[i].value}]);
                        aopcl = aopcl.concat([{ label: this.stringView(this.appended_column[i].text) , name: this.appended_column[i].value , type: this.appended_column[i].type}]);
                    }

                    this.appended_options = this.appended_options.concat(aop);
                    this.default_options = this.default_options.concat(dop);
                    this.column_options = this.column_options.concat(co);
                    this.columns = this.columns.concat(cl);
                    this.columns = this.columns.concat(aopcl);
                    this.columns.forEach((column) => {this.sortOrders[column.name] = -1;});
                    if(this.employees.length == 0)
                        this.blankmsg = "No employee found.";
                    else
                    {
                        this.length_options = [{ value: 20, text: "20" },
                                            { value: 50, text: "50" },
                                            { value: 100, text: "100" },
                                            { value: 200, text: "200" },
                                            { value: 500, text: "500" },
                                            { value: this.employees.length, text: "All" }
                                        ];
                        this.people = this.employees.length;
                        this.sortBy('name');
                    }

                    //console.log(this.columns);
                    //console.log(this.default_options);
                    //console.log(this.employees);

                }
                else
                {
                    let dop = [];
                    let cl = [];
                    this.default_column.forEach(element => {
                        cl = cl.concat([{ label: this.stringView(element) , name: element }]);
                        dop = dop.concat([{ text: this.stringView(element) , value: element }]);
                    });
                    this.columns = this.columns.concat(cl);
                    this.default_options = this.default_options.concat(dop);

                    this.blankmsg = "No employee found.";
                }

                this.showoverlay = false;

            },
            actionEmployee:function(em_id,action_id)
            {
                let value = [];
                value[this.primary_key] = em_id;
                value['action_id'] = action_id;
                value['selected'] = [];
                value['leave_type_id'] = this.search_by_filter.leave_type_id;
                this.$emit('childToParent',value);
            },
            getDateObj(start_month)
            {       let str_month_arr = [];
                    var m_names = ['january', 'february', 'march',
                            'april', 'may', 'june', 'july',
                            'august', 'september', 'october', 'november', 'december'];

                            if(start_month.includes("-"))
                            {
                                 str_month_arr = start_month.split("-");
                            }
                            else
                            {
                                 str_month_arr = start_month.split(" ");
                            }

                    var yr1   = parseInt(str_month_arr[1]);
                    var mt  = str_month_arr[0];
                    var mon1 = m_names.indexOf(mt);
                    var d1 = new Date(yr1, mon1).getTime();
                    return d1;
            },

        },
        created: function(){


            /*if(this.$cookies.isKey("column_selected"))
            {
                if(this.$cookies.get("column_selected") != null && this.$cookies.get("column_selected") != '')
                    this.column_selected = this.$cookies.get("column_selected").split(',');
            }  */
            this.generateList();



            $(window).on('load', function (e) {
                setTimeout(function(){
                    $('.div1').width($('table.employee-list-table').width());
                    $('.div2').width($('table.employee-list-table').width());
                    if($('table.employee-list-table').width() > $('.wrapper1').width()){
                        //alert($('table.employee-list-table').width());
                        $('.wrapper1').show();
                    }else{
                        //alert('Its not bigger');
                        $('.wrapper1').hide();
                    }
                }, 2000);
                $('.wrapper1').on('scroll', function (e) {
                    $('.wrapper2').scrollLeft($('.wrapper1').scrollLeft());
                });
                $('.wrapper2').on('scroll', function (e) {
                    $('.wrapper1').scrollLeft($('.wrapper2').scrollLeft());
                });

                $(document).on("click",".trz-custom-dropdown .custom-switch input",function() {
                    setTimeout(function(){
                        $('.div1').width($('table.employee-list-table').width());
                        $('.div2').width($('table.employee-list-table').width());
                        if($('table.employee-list-table').width() > $('.wrapper1').width()){
                            $('.wrapper1').show();
                        }else{
                            $('.wrapper1').hide();
                        }
                    }, 500);
                });
            });

        },
        computed:
        {
            filteredData()
            {
                this.backdoor;

                //alert(this.backdoor);

                let filtered_list = this.employees;

                let search_by_custom_fields = this.search_by_filter;

                var search_terms = new Array();

                Object.keys(search_by_custom_fields).forEach(key => {

                    if(search_by_custom_fields[key] != '' && (this.column_selected.includes(key) || this.default_column.includes(key) || this.filter_by_id.includes(key)))
                    {
                        search_terms.push(`${key}:${search_by_custom_fields[key]}`);
                    }
                    else
                    {

                        this.search_by_filter[key] = '';
                    }
                });

                if(search_terms.length>0)
                {


                    for (var i = 0; i < search_terms.length; i++)
                    {
                        const term_to_search = search_terms[i].split(":");
                        let search_key = term_to_search[0];
                        let search_value =  term_to_search[1];

                        if(search_key == 'leave_type_id')
                        {
                            let search_values = parseInt(search_value);
                            filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => { return (row['leave_type_ids']).indexOf(search_values) > -1;})});
                        }
                        if(search_key == 'status')
                        {
                            filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[search_key]).toLowerCase().indexOf(search_value.toLowerCase()) == 0;})});
                        }
                        else
                        {
                            filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[search_key]).toLowerCase().indexOf(search_value.toLowerCase()) > -1;})});
                        }

                    }


                    this.selected_ids = this.selected;
                    let value = [];
                    value[this.primary_key] = 0;
                    value['action_id'] = 0;
                    value['selected'] = this.selected;
                    value['leave_type_id'] = this.search_by_filter.leave_type_id;
                    this.$emit('childToParent',value);

                    this.pagination.currentPage = 1;
                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";
                }


                if (this.search)
                {

                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});


                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";
                }

                let sortKey = this.sortKey;

                //if(typeof this.sortOrders[sortKey] == 'undefined')this.sortOrders[sortKey] = -1;
                //else this.sortOrders[sortKey] = 1;

                let order = this.sortOrders[sortKey] || 1;

                //alert(sortKey + ' >> ' + order);

                if (sortKey)
                {
                    filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
                            a = String(a[sortKey]).toLowerCase();
                            b = String(b[sortKey]).toLowerCase();

                            if (this.columns[index].type && this.columns[index].type === 'date')
                            {
                                return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                            }
                            if (this.columns[index].type && this.columns[index].type === 'monthyear')
                            {
                                return (a === b ? 0 : this.getDateObj(a) > this.getDateObj(b)  ? 1 : -1) * order;
                            }

                            else if (this.columns[index].type && this.columns[index].type === 'number')
                            {
                                a = this.toMoney(a);
                                b = this.toMoney(b);

                                return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                            }
                            else
                            {
                                let aa = (a === b ? 0 : a > b ? 1 : -1) * order;
                                return (a === b ? 0 : a > b ? 1 : -1) * order;
                            }
                        }
                    );
                }

                this.people = filtered_list.length;
                return filtered_list;
            },
            paginatedData()
            {
                this.backdoor;

                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },
            selectAll: {
                get: function () {
                    // return this.employees ? this.selected.length == this.employees.length : false;
                    return this.filteredData ? this.selected.length == this.filteredData.length : false;
                },
                set: function (value) {
                    var selected = [];
                    if (value) {
                        this.filteredData.forEach(function (user) {
                            selected.push(user.employee_id);
                        });
                    }
                    this.selected = selected;
                }
            },
            clickSelect()
            {

                if(this.selected.length !=  this.selected_ids.length)
                {
                    this.selected_ids = this.selected;
                    let value = [];
                    value[this.primary_key] = 0;
                    value['action_id'] = 0;
                    value['selected'] = this.selected;
                    value['leave_type_id'] = this.search_by_filter.leave_type_id;
                    this.$emit('childToParent',value);
                }
            },
        }
    }
</script>
<style>

.employee-list-table tr td:last-child {
	padding-right: 20px;
}
.action_thead {
	text-align: right;
}
.btn.hov-button {
	font-size: 12px;
	padding: 4px;
}

.table-sticky{
    position: relative;
}
.table-sticky thead td {

    position: sticky;
    top: 0;
    background: #CCF4FE;
    z-index: 9;
}
.table-parent{
    /* height: 100vh; */
   height: 700px;
    /* max-height: 100vh; */
    overflow: auto;

}

</style>
